import getFuturePeriod from "./get-future-period";

export default function getFutureSeason(seasons, { state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  return getFuturePeriod(seasons);
}
